import { IAccountMenu } from '@/core/types/coreTypes'
import AppStore from '@/AppStore'

export function hasPermission(actions: string | unknown[]) {
  const userPermissions: IAccountMenu[] =
    AppStore.getters['auth/getUserPermissions']
  return userPermissions?.some(item => actions.includes(item.codeName))
}
